import { apiFetch } from '../api';

const API = '/api';

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Ошибка ${res.status}`);
  }
  return data;
}

export async function fetchAccounts() {
  const res = await apiFetch(`${API}/financial/accounts/`);
  const data = await parseJson(res);
  return data.accounts || [];
}

export async function fetchItems(params = {}) {
  const q = new URLSearchParams();
  if (params.accountId) q.set('account_id', String(params.accountId));
  if (params.enabledOnly) q.set('enabled_only', '1');
  const suffix = q.toString() ? `?${q}` : '';
  const res = await apiFetch(`${API}/financial/rules/${suffix}`);
  const data = await parseJson(res);
  return data.items || data.rules || [];
}

export async function fetchLedger(params = {}) {
  const q = new URLSearchParams();
  if (params.startDate) q.set('start_date', params.startDate);
  if (params.endDate) q.set('end_date', params.endDate);
  if (params.accountId) q.set('account_id', String(params.accountId));
  if (params.expenseItemId) q.set('expense_item_id', String(params.expenseItemId));
  if (params.limit) q.set('limit', String(params.limit));
  const res = await apiFetch(`${API}/financial/payments/?${q}`);
  const data = await parseJson(res);
  return data.payments || [];
}

export async function fetchOccurrences() {
  const res = await apiFetch(`${API}/financial/occurrences/`);
  const data = await parseJson(res);
  return data.occurrences || [];
}

export async function resolveOccurrence(id, body, { revise = false } = {}) {
  const res = await apiFetch(`${API}/financial/occurrences/${id}/resolve/`, {
    method: revise ? 'PATCH' : 'POST',
    body: JSON.stringify(body),
  });
  return parseJson(res);
}

export async function createAccount(body) {
  const res = await apiFetch(`${API}/financial/accounts/create/`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return parseJson(res);
}

export async function updateAccount(id, body) {
  const res = await apiFetch(`${API}/financial/accounts/${id}/update/`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
  return parseJson(res);
}

export async function deleteAccount(id) {
  const res = await apiFetch(`${API}/financial/accounts/${id}/delete/`, { method: 'DELETE' });
  return parseJson(res);
}

export async function createItem(body) {
  const res = await apiFetch(`${API}/financial/items/create/`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return parseJson(res);
}

export async function updateItem(id, body) {
  const res = await apiFetch(`${API}/financial/items/${id}/update/`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
  return parseJson(res);
}

export async function disableItem(id) {
  const res = await apiFetch(`${API}/financial/items/${id}/disable/`, { method: 'POST' });
  return parseJson(res);
}

export async function deleteItem(id) {
  const res = await apiFetch(`${API}/financial/items/${id}/delete/`, { method: 'DELETE' });
  return parseJson(res);
}

export async function createLedgerEntry(body) {
  const res = await apiFetch(`${API}/financial/ledger/create/`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return parseJson(res);
}

export async function updateLedgerEntry(id, body) {
  const res = await apiFetch(`${API}/financial/ledger/${id}/update/`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
  return parseJson(res);
}

export async function deleteLedgerEntry(id) {
  const res = await apiFetch(`${API}/financial/ledger/${id}/delete/`, { method: 'DELETE' });
  return parseJson(res);
}

export async function fetchPaymentReport(endDate) {
  return parseJson(await apiFetch(`${API}/financial/report/?${new URLSearchParams({ end_date: endDate })}`));
}
